var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stripBB"}},[_c('b-container',{staticClass:"containerStrip"},[_c('p',{staticClass:"ciclic-plataform"},[_vm._v("Uma empresa")]),_c('img',{staticClass:"bbseguros_logo",attrs:{"src":"https://static.ciclic.com.br/svg/bb-seguros-logo.svg","alt":"Logo BB Seguros","height":"26","loading":"lazy","width":"150"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }